import { FormatStructureEditor } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { FormatObjectsCountShortageAlert } from "../alerts";
import { AbstractFormatValidator } from "./AbstractFormatValidator";

export class ObjectsValidator extends AbstractFormatValidator {
  constructor() {
    super();
  }

  private get countMin(): number {
    return this.configuration.formatEditor.behavior.format.editor.object.count.min;
  }

  public validate(format: FormatStructureEditor): IFormatAlert[] {
    const objects = this.extractObjects(format);
    return this.concat(
      objects.length < this.countMin
        ? new FormatObjectsCountShortageAlert(this.countMin, true)
        : null,
    );
  }
}
